<template>
  <div>
    <div class="attribute-wrap" :class="parent_component != 'note' ? 'small' : ''" v-if="permission.access">
      <div v-for="(property, index) in getProperties(attribute_id, attributes)" :key="index" class="attribute" >
        {{ property.property_name }}
        <div v-if="editMode" class="attribute-times pointer" @click="deleteAttributeProperty(property.property_id)"><font-awesome-icon :icon="['fal', 'times']" /></div>
      </div>
      <div v-if="editMode" class="attribute-suggest">
        <div class="attribute-add" @click="activeAttribute()" v-if="!property_input">
          <div class="flex-row" v-if="permission.access"><font-awesome-icon :icon="['fal', 'plus']" style="margin-right: 3px;" />マッピングを追加</div>
          <div style="margin: 0; width:80px" v-else><font-awesome-icon :icon="['fas', 'lock']" /></div>
        </div>
        <el-input
            placeholder="マッピングを入力"
            class="attribute-input"
            size="mini"
            v-model="new_attributes"
            v-show="property_count > 0"
            @focus="suggest_attribute = true"
            @blur="suggest_on ? '' : (suggest_attribute = false) & (property_input = false) & (suggest_hover = -1)"
            @keydown.up.native="suggestHover('up', 'attribute-box')"
            @keydown.down.native="suggestHover('down', 'attribute-box')"
            @keypress.enter.native="suggest_hover > -1 ? addAttribute(property_list[suggest_hover].property_id) : addAttribute(new_attributes)"
            id="autoFocus"
            v-else
        ></el-input>
        <div class="attribute-suggest-box-wrap" id="attribute-box" :class="property_list.length > 9 ? 'scroll' : ''" v-if="suggest_attribute">
          <div
              v-for="(property, index) in property_list"
              :key="property.property_id"
              class="attribute-suggest-box"
              :class="suggest_hover == index ? 'hover' : ''"
              @click="addAttribute(property.property_id)"
              @mouseover="(suggest_on = true) && (suggest_hover = index)"
              @mouseleave="(suggest_on = false) && (suggest_hover = -1)"
              v-show="!property.added && property_count > 0"
          >
            <div class="attribute small">{{ property.property_name }}</div>
            <div class="flex-space"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="attribute-add" @click="activeAttribute()">
        <div style="margin: 0; width:80px"><font-awesome-icon :icon="['fas', 'lock']" /></div>
      </div>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const addAttributeAPI = root + "/api/admin/add_attribute";
const deleteAttributePropertyAPI = root + "/api/admin/delete_attribute";
const loadAttributeAPI = root + "/api/list/load_attribute";

export default {
  name: "attributeMapping",
  props: {
    id: { type: String, required: true },
    attributes: {
      type: Array,
      required: true
    },
    parent_component: { type: String },
    influencer_index: { type: Number },
    attribute_sns_type: { type: Number, required: true },
    attribute_id: { type: Number, required: true },
    editMode: {type: Boolean, required: true},
  },
  data() {
    return {
      drawer: false,
      property_input: false,
      new_attributes: null,
      suggest_attribute: false,
      suggest_on: false,
      suggest_hover: -1,
      suggest_loading: false,
      property_list: [],
      requestId: +new Date(),
      property_count: 0,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    permission() {
      return this.$store.state.permission.note;
    },
  },
  mounted() {},
  methods: {
    activeAttribute() {
      if (this.permission.edit) {
        this.property_input = true;
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    loadAttribute() {
      this.suggest_loading = true;
      this.axios
          .get(loadAttributeAPI, {
            params: {
              token: this.token,
              sns_type: this.attribute_sns_type,
              influencer_id: this.id,
              attribute_id: this.attribute_id
            },
          })
          .then((response) => {
            this.property_list = response.data.attributes[0]?.properties || [];
            this.property_count = this.property_list.length;
            this.suggest_loading = false;
            if (this.property_count < 1) {
              this.property_input = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch(error => {
            this.property_input = false;
          });
    },
    addAttribute(property_id) {
      var params = new URLSearchParams();
      params.append("sns_type", this.attribute_sns_type);
      params.append("influencer_id", this.id);
      params.append("token", this.token);
      params.append("property_id", property_id);
      this.axios.post(addAttributeAPI, params).then((response) => {
        this.new_attributes = "";
        this.property_input = false;
        this.suggest_attribute = false;
        this.suggest_hover = -1;
        this.suggest_on = false;
        this.$emit("updateAttributeProperties", "add", this.attribute_id, response.data.new_attributes, this.influencer_index);
      });
      this.loadAttribute();
    },
    deleteAttributeProperty(property_id) {
      if (this.permission.edit) {
        // this.$emit("updateTag", "delete", tag_index, "", this.influencer_index);
        var params = new URLSearchParams();
        params.append("sns_type", this.attribute_sns_type);
        params.append("influencer_id", this.id);
        params.append("token", this.token);
        params.append("property_id", property_id);
        this.axios
            .post(deleteAttributePropertyAPI, params)
            .then((response) => {
              this.$emit("updateAttributeProperties", "add", this.attribute_id, response.data.new_attributes, this.influencer_index);
            })
            .catch(() => {});
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    suggestHover(type, position) {
      if (type == "up") {
        if (this.suggest_hover == -1) this.suggest_hover += 0;
        else this.suggest_hover -= 1;
      } else if (type == "down") {
        if (this.suggest_hover == this.tag_list.length - 1) this.suggest_hover += 0;
        else this.suggest_hover += 1;
      }
      var suggest_position = 30;
      var target = document.getElementById(position);
      target.scrollTop = (this.suggest_hover - 5) * suggest_position;
    },
    getProperties(attributeId, attributes) {
      const attribute = attributes.find(attribute => attribute.attribute_id === attributeId);
      if (!attribute || attribute.properties === undefined) {
        return [];
      }
      return attribute.properties;
    }
  },
  watch: {
    property_input() {
      this.loadAttribute();
      if (this.property_input == true) {
        setTimeout(() => {
          try {
            document.getElementById("autoFocus").focus();
            // eslint-disable-next-line no-empty
          } catch (error) {
            // 特に何もしない
          }
        }, 100);
      }
    },
  },
};
</script>
